/* global wx */

export function getMiniProgramBridge() {
    if (typeof wx === "undefined") return null;
    return wx?.miniProgram || null;
}

export function postMiniProgramMessage(message) {
    getMiniProgramBridge()?.postMessage?.(message);
}

export function navigateMiniProgram(url) {
    getMiniProgramBridge()?.navigateTo?.({ url });
}

export function navigateMiniProgramLogout() {
    postMiniProgramMessage({ type: "logout" });
    navigateMiniProgram("/pages/index/index?login=1");
}
